<div class="row mt-3">
    <div class="mx-auto"  style="display: flex;align-items: flex-end;">
      <img id="logo" width="100%" height="70%" src="web-assets/images/Noor-logo-01.svg">
    </div>
  </div>